
import { useState, useCallback } from "react";
import { PaginationState, ContentItem } from "../types";

export function useContentPagination(allContent: ContentItem[]) {
  // Pagination state
  const [pagination, setPagination] = useState<PaginationState>({
    currentPage: 1,
    pageSize: 5,
    totalItems: allContent.length
  });

  // Get paginated content
  const getPaginatedContent = useCallback(() => {
    const start = (pagination.currentPage - 1) * pagination.pageSize;
    const end = start + pagination.pageSize;
    return allContent.slice(start, end);
  }, [allContent, pagination.currentPage, pagination.pageSize]);

  // Handle page change
  const handlePageChange = (page: number) => {
    setPagination(prev => ({
      ...prev,
      currentPage: page
    }));
  };

  // Update total items when allContent changes
  const updateTotalItems = useCallback((total: number) => {
    setPagination(prev => ({
      ...prev,
      totalItems: total
    }));
  }, []);

  return {
    pagination,
    getPaginatedContent,
    handlePageChange,
    updateTotalItems
  };
}
